<template>
    <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-indigo-500" 
        :value="valueOption" @input="updateValue($event)">
        <option v-for="option in options" :value="option" :key="option">{{ option }}</option>
    </select>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch, onMounted } from 'vue';

const emit = defineEmits(['update:modelValue', 'change']);
const props = defineProps({
    modelValue: {
        type: String,
        required: true
    },
    options: {
        type: Array,
        required: true
    }
})
const valueOption = ref(props.modelValue)
const updateValue = (event) => {
    emit('update:modelValue', event.target.value);
    emit('change', event.target.value)
}

onMounted( () => {
    valueOption.value = props.modelValue;
})
watch( () => props.modelValue, () => {
    valueOption.value = props.modelValue;
})
</script>